import { videos } from "@/mocks/videos";
import type { VideoItem } from "@/types/video";

const allVideos = videos as VideoItem[];

export function getAllVideos(): VideoItem[] {
  return allVideos;
}

export function getVideoById(id: string): VideoItem | undefined {
  return allVideos.find((item) => item.id === id);
}

export function getVideosByType(type: string): VideoItem[] {
  return allVideos.filter((item) => item.type === type);
}

export function getFeaturedVideos(): VideoItem[] {
  return allVideos.filter((item) => item.isFeatured);
}

export function getLatestVideos(limit?: number): VideoItem[] {
  const list = [...allVideos].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );
  return typeof limit === "number" ? list.slice(0, limit) : list;
}

export function getHotVideos(limit?: number): VideoItem[] {
  const list = [...allVideos].sort((a, b) => b.views - a.views);
  return typeof limit === "number" ? list.slice(0, limit) : list;
}

export interface FilterOptions {
  type?: string;
  region?: string;
  year?: string;
  tag?: string;
  keyword?: string;
  sort?: string;
}

export function filterVideos(options: FilterOptions): VideoItem[] {
  const { type, region, year, tag, keyword, sort } = options;
  const kw = (keyword || "").trim().toLowerCase();

  let list = allVideos.filter((item) => {
    if (type && type !== "all" && item.type !== type) return false;
    if (region && region !== "全部" && item.region !== region) return false;
    if (year && year !== "全部") {
      if (year === "2020及以前") {
        if (Number(item.year) > 2020) return false;
      } else if (item.year !== year) {
        return false;
      }
    }
    if (tag && tag !== "全部" && !item.tags.includes(tag)) return false;
    if (kw) {
      const haystack = `${item.title} ${item.tags.join(" ")} ${item.region} ${item.cast.join(" ")} ${item.director}`.toLowerCase();
      if (!haystack.includes(kw)) return false;
    }
    return true;
  });

  const sortKey = sort || "latest";
  list = [...list].sort((a, b) => {
    if (sortKey === "hot") return b.views - a.views;
    if (sortKey === "rating") return b.rating - a.rating;
    return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
  });

  return list;
}

export function getRelatedVideos(item: VideoItem, limit = 4): VideoItem[] {
  const scored = allVideos
    .filter((v) => v.id !== item.id)
    .map((v) => {
      let score = 0;
      if (v.type === item.type) score += 2;
      score += v.tags.filter((t) => item.tags.includes(t)).length * 3;
      return { v, score };
    })
    .sort((a, b) => b.score - a.score || b.v.views - a.v.views)
    .map((entry) => entry.v);
  return scored.slice(0, limit);
}

export function paginate<T>(list: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

export function formatViews(views: number): string {
  if (views >= 100000000) return `${(views / 100000000).toFixed(1)}亿`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
}

export function getTypeName(type: string): string {
  if (type === "movie") return "电影";
  if (type === "tv") return "电视剧";
  if (type === "variety") return "综艺";
  return "影视";
}